import shipIconUrl from "../../shared/assets/fi-sr-cursor.png";
import minus from "../../shared/assets/minus-small.svg";
import plus from "../../shared/assets/plus-small.svg";
import shipImage from "../../shared/assets/ship.svg";
// @ts-expect-error
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { useRef, useEffect } from "react";

const getReal = (str: string) => {
  return str
    .split("")
    .map((x) => String.fromCharCode(x.charCodeAt(0) - 1))
    .join("");
};

type Props = {
  center: any;
  zoom: any;
  shipCoordinates: any;
};

const Map = ({ center, zoom, shipCoordinates }: Props) => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const shipMarker = useRef(null);

  useEffect(() => {
    // We are applying URL restrictions to this token so it cannot be used outside of Opslink
    // https://docs.mapbox.com/help/how-mapbox-works/access-tokens/#using-url-restrictions

    const at = getReal(
      "ql/fzK2Jkpjcnmscz2kZYKobXytJjxjZTJ7JnOuNU[jcXqsO{Cld3tzdYG7cnu{fHhxO3djgR/3wC[vsGPomgMdy7HIlVsnR",
    );
    mapboxgl[getReal("bddfttUplfo")] = at;

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [center.lng, center.lat],
      zoom,
    });

    // Remove compass control - it won't be added
    // Add container for custom controls and position it top right
    const customControlsContainer = document.createElement("div");
    customControlsContainer.className = "mapboxgl-ctrl";
    customControlsContainer.style.position = "absolute";
    customControlsContainer.style.top = "10px";
    customControlsContainer.style.right = "10px";

    // Add custom recenter control
    const recenterControl = document.createElement("div");
    recenterControl.innerHTML = `<img src="${shipImage}" alt="Recenter" style="width: 32px; height: 32px; cursor: pointer;">`;
    recenterControl.style.width = "32px";
    recenterControl.style.height = "42px";
    recenterControl.style.backgroundColor = "#fff";
    recenterControl.style.cursor = "pointer";
    recenterControl.style.padding = "4px";
    recenterControl.style.margin = "5px";
    recenterControl.style.borderRadius = "5px";
    // @ts-expect-error
    recenterControl.alt = "Ship";
    recenterControl.onclick = () => {
      // @ts-expect-error
      map.current.flyTo({
        center: [center.lng, center.lat],
        zoom,
      });
    };
    customControlsContainer.appendChild(recenterControl);

    // Add custom zoom in control
    const zoomInControl = document.createElement("div");
    zoomInControl.innerHTML = `<img src="${plus}" alt="Zoom Out" style=" cursor: pointer;">`;
    zoomInControl.style.width = "30px";
    zoomInControl.style.height = "32px";
    zoomInControl.style.backgroundColor = "#fff";
    zoomInControl.style.cursor = "pointer";
    zoomInControl.style.padding = "4px";
    zoomInControl.style.margin = "5px";
    zoomInControl.style.borderTopLeftRadius = "5px";
    zoomInControl.style.borderTopRightRadius = "5px";
    zoomInControl.style.alignContent = "center";
    // @ts-expect-error
    zoomInControl.alt = "ZoomIn";
    zoomInControl.onclick = () => {
      // @ts-expect-error

      map.current.zoomIn();
    };
    customControlsContainer.appendChild(zoomInControl);

    // Add custom zoom out control
    const zoomOutControl = document.createElement("div");
    zoomOutControl.innerHTML = `<img src="${minus}" alt="Zoom Out" style="cursor: pointer;">`;
    zoomOutControl.style.width = "30px";
    zoomOutControl.style.height = "32px";
    zoomOutControl.style.backgroundColor = "#fff";
    zoomOutControl.style.cursor = "pointer";
    zoomOutControl.style.padding = "4px";
    zoomOutControl.style.margin = "5px";
    zoomOutControl.style.borderBottomLeftRadius = "5px";
    zoomOutControl.style.borderBottomRightRadius = "5px";
    zoomOutControl.style.alignContent = "center";
    // @ts-expect-error
    zoomOutControl.alt = "ZoomOut";
    zoomOutControl.onclick = () => {
      // @ts-expect-error
      map.current.zoomOut();
    };
    customControlsContainer.appendChild(zoomOutControl);

    // Append the container to the map
    // @ts-expect-error
    mapContainer.current.appendChild(customControlsContainer);

    // Add ship marker
    shipMarker.current = new mapboxgl.Marker({
      element: createShipIcon(shipIconUrl), // Create custom ship icon
      anchor: "bottom", // Adjust anchor position if needed
    })
      .setLngLat([shipCoordinates.lng, shipCoordinates.lat])
      .addTo(map.current);

    // Cleanup function to remove map on component unmount
    return () => {
      // @ts-expect-error
      map.current.remove();
    };
  }, [center, zoom, shipCoordinates]);

  // Function to create custom ship icon
  const createShipIcon = (
    // @ts-expect-error

    iconUrl,
  ) => {
    const shipElement = document.createElement("img");
    shipElement.src = iconUrl;
    shipElement.style.width = "16px";
    shipElement.style.height = "16px";
    return shipElement;
  };

  return <div ref={mapContainer} style={{ height: "200px", width: "100%" }} />;
};

export default Map;
